<template>
  <el-dialog :visible="show" @close="closeModal">
    <ModalHeader slot="title" title="Thông tin tài khoản" />
    <div v-if="user">
      <el-row class="info-container">
        <el-col :span="12">
          Tên người dùng: <b>{{ user.name }}</b>
        </el-col>
        <el-col :span="12">
          Email:
          <b>{{ user.email }}</b>
        </el-col>
        <el-col :span="12"> Loại tài khoản: <PricingPlanTag :name="user.subscription.plan.name" /> </el-col>
        <el-col :span="12">
          Trạng thái:
          <b :class="user.active ? 'green' : 'red'">{{ user.active ? 'Đã kích hoạt' : 'Chưa kích hoạt' }}</b>
        </el-col>
        <el-col :span="12">
          Ngày tạo: <b>{{ formatDate(user.createTime) }}</b>
        </el-col>
        <el-col :span="12">
          Ngày hết hạn: <b>{{ formatDate(user.subscription.to) }}</b>
        </el-col>
        <el-col :span="12">
          Loại E-mail: <b>{{ user.anonymousEmail ? 'Email ảo' : 'Email người dùng' }}</b>
        </el-col>
        <el-col :span="12">
          Xác thực E-mail:
          <b :class="user.emailConfirmed ? 'green' : 'red'">
            {{ user.emailConfirmed ? 'Đã xác thực' : 'Chưa xác thực' }}
          </b>
        </el-col>
      </el-row>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeModal">Trở về</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { updateInfo } from '@/services/user_service'
import ModalHeader from '@/components/common/ModalHeader.vue'
import CommonButton from '@/components/common/CommonButton.vue'
import PricingPlanTag from '@/components/common/PricingPlanTag.vue'
import { formatDate, formatDateTime } from '@/helpers/timeHelper.js'

export default {
  name: 'UserDetailInfoModal',
  components: { PricingPlanTag, CommonButton, ModalHeader },
  data: function () {
    return {
      show: false,
      user: null,
      refs: {
        CONFIRM_BUTTON: 'CONFIRM_BUTTON',
      },
      formatDate,
    }
  },
  methods: {
    showModal(user) {
      this.user = user
      this.show = true
    },
    closeModal() {
      this.show = false
    },
  },
}
</script>

<style lang="scss" scoped>
.info-container {
  div {
    padding: 5px;
  }
  * {
    font-size: 1.1rem;
  }
}
.green {
  color: forestgreen;
}
</style>
